export default __webpack_public_path__ + "static/media/school1.d60ad401.webp";